const dictionaryData = [
	{
		id: 'budget',
		title: {
			da: 'Budget',
			kl: 'Missingersuut',
		},
		description: {
			da: `Et budget er jeres bedste bud på kommende indtægter og udgifter.
			<br /><br />Hvis I trykker på <span class="plus"></span> kan I se detaljerne i jeres budget.`,
			kl: `Missingersuut tassaavoq isertitassassi aningaarsartuutissassilu sapinngisamik eqqoriarneri.
			<br /><br />Una<span class="plus"></span> toorussiuk missingersuutissi immikkuualuttortai takusinnaavasi.`,
		}
	},
	{
		id: 'turnover',
		title: {
			da: 'Omsætning',
			kl: 'Kaaviiaartitat',
		},
		description: {
			da: 'Omsætningen består af alle virksomhedens indtægter i en given periode',
			kl: 'Piffissami pineqartumi suliffeqarfiup isertitai tamarmik kaaviiaartitatut taaneqartarput',
		}
	},
	{
		id: 'expenses',
		title: {
			da: 'Omkostninger',
			kl: 'Aningaasartuutit',
		},
		description: {
			da: 'Omkostninger består af alle virksomhedens udgifter i en given periode',
			kl: 'Piffissami pineqartumi suliffeqarfiup aningaasartuutai tamarmik aningaasartuutitut taaneqartarput',
		}
	},
	{
		id: 'fixed-expenses',
		title: {
			da: 'Faste udgifter',
			kl: 'Aningaasartuutit ataavartut',
		},
		description: {
			da: 'Faste udgifter, er de udgifter, som du ved kommer hver måned. Det kan være husleje, internet, forsikringer og andet.',
			kl: 'Aningaasartuutit ataavartut tassaapput aningaasartuutit qaammatit tamaasa takkuttartut. Ineqarnermuusinnaavoq, nittartagaqarnermut, sillimmasersuutit allallu.'
		}
	},
	{
		id: 'variable-expenses',
		title: {
			da: 'Variable udgifter',
			kl: 'Aningaasartuutit allanngorartut',
		},
		description: {
			da: 'Variable udgifter ændrer sig alt efter hvor meget I sælger. Det kan være udgifter til emballage, indkøb transport.',
			kl: 'Aningaasartuutit allanngorartut qanoq tunisaqartiginersi apeqqutaalluni allanngortartuupput. Poortuutissanut, pisiniarnernut nassiussinermulluunniit aningaasartuutaasinnaapput.',
		}
	},
	{
		id: 'profit',
		title: {
			da: 'Overskud',
			kl: 'Sinneqartoorutit',
		},
		description: {
			da: 'Overskuddet er forskellen mellem omsætningen og alle virksomhedens udgifter. Spillet handler om at få så meget overskud som muligt.',
			kl: 'Isertitat aamma suliffeqarfiup aningaasartuutai tamakkeraanni nikingassutaa sinneqartoorutaavoq. Pinnguaammi sapinngisamik sinneqartooruteqarnerpaaffissaqarniarneq siunertaavoq.',
		}
	},
	{
		id: 'liquidity',
		title: {
			da: 'Likviditet',
			kl: 'Akiliisinnaassuseqarneq',
		},
		description: {
			da: 'Likviditet er de penge I har stående på kontoen som I kan bruge af.',
			kl: 'Akiliisinnaassuseqarnermi pineqarput kontumi uninngasuutissinni aningaasat atorsinnaasasi.',
		}
	},
	{
		id: 'stock',
		title: {
			da: 'Lager',
			kl: 'Toqqorsivik',
		},
		description: {
			da: 'Lageret viser antallet af t-shirts, som I har produceret, men ikke solgt endnu',
			kl: 'Toqqorsivimmi takuneqarsinnaapput, tujuuluaqqat sanasimasassi kisianni suli tunisimanngisassi amerlassusaat',
		}
	},
	{
		id: 'prod-capacity',
		title: {
			da: 'Produktionskapacitet',
			kl: 'Nioqqutissiat amerlassuserisinnaasaat',
		},
		description: {
			da: 'Hvor mange t-shirts I kan nå at lave print på pr kvartal.',
			kl: 'Ukiup sisamararterutaanut tujuuluaqqat naqissinnaasassi amerlassusaat.',
		}
	},
	{
		id: 'purchase',
		title: {
			da: 'Indkøb',
			kl: 'Pisiniarneq',
		},
		description: {
			da: 'Hvor mange t-shirts uden tryk I indkøber i dette kvartal.',
			kl: 'Tujuuluaqqat naqinneqanngitsut ukiup sisamararterutaani uani pisiassi amerlassusaat.',
		}
	},
	{
		id: 'purchase-price',
		title: {
			da: 'Indkøbspris',
			kl: 'Pisiarinerani akia',
		},
		description: {
			da: 'Indkøbspris, er den pris, som I betaler for de t-shirts uden tryk I skal lave tryk på og sælge videre.',
			kl: 'Pisiarinerani akia tassaavoq aki tujuuluaqqanut naqinneqanngitsunut naqeriarlugit tuniniaqqitassassinnut akiliutersi.',
		}
	},
	{
		id: 'prod-price',
		title: {
			da: 'Produktionspris',
			kl: 'Nioqutissiornerup akia',
		},
		description: {
			da: 'Produktionsprisen er alle de omkostninger, som I har til blæk og slid på maskiner. Prisen er delt ud på prisen pr t-shirt.',
			kl: 'Nioqqutissiornerup akia tassaavoq atortut pilikkianut aserfallakkiartornerinullu aningaasartuutisi tamarmik. Tujuuluaqqap ataatsip akiani akiliutigisarsi agguataarneqarpoq.',
		}
	},
	{
		id: 'financing',
		title: {
			da: 'Finansiering',
			kl: 'Aningaasaliineq',
		},
		description: {
			da: 'Finansiering betyder at skaffe penge til virksomheden, som ikke kommer fra virksomhedens salg. I spillet kan I tage banklån og tage en partner ind i firmaet.',
			kl: 'Aningaasaliineq tassaavoq suliffeqarfiup tunisineraninngaanniinngitsumik suliffeqarfimmut aningaasarsiorneq. Pinnguaammi aningaaserivimmut taarsigassarsiniarsinnaavusi aamma suliffeqarfimmi piginneqataasumik ilalerluni.',
		}
	},
	{
		id: 'accounting',
		title: {
			da: 'Regnskab',
			kl: 'Naatsorsuutit',
		},
		description: {
			da: 'Et regnskab er en opgørelse over alle jeres udgifter og indtæger i en bestemt periode.',
			kl: 'Naatsorsuutit tassaapput piffissami aalajangersimasumi aningaasartuutissi isertitassilu tamaasa naatsorsorneri.',
		}
	},
	{
		id: 'design-quality',
		title: {
			da: 'Design og kvalitet',
			kl: 'Iluseq aamma pitsaassuseq',
		},
		description: {
			da: 'Jo lækrere t-shirt kvalitet, og jo federe logo der er på t-shirtsne, jo mere sandsynligt er det at nogen køber dem. I spillet bliver de to ting lagt sammen til en score mellem 1-10. ',
			kl: 'Tujuuluaqqat pitsaassuseqarneruppata aamma tujuuluaqqani ilisarnaatit torraassuseqarneruppata pisiarineqarnissaat ilimanaateqarnerussaaq. Pinnguaammi taakku marluk 1-imiit 10-mut katillugit nalilersorneqarsinnaapput.',
		}
	},
	{
		id: 'dict-customers',
		title: {
			da: 'Kunder pr kvartal',
			kl: 'Ukiup sisamararterutikkaarlugit pisisut'
		},
		description:{
			da:  `Kunder pr. kvartal fortæller hvor mange kunder der kommer ind i butikken i et kvartal.
			<br />I har meget trofaste kunder, så en stor del af de kunder der kommer i butikken et kvartal, vil komme igen næste kvartal. I kan få flere kunder ved at lave markedsføring.`,
			kl: `Ukiup sisamararterutaani pisiniartut tassaavoq ukiup sisamararterutaanut pisiniarfimmut pisiniat qassit isersimanerisa takussutissaat`,
		}
	},
	{
		id: 'dict-buying-customers',
		title: {
			da: 'Antal der køber',
			kl: 'Pisisut amerlassusaat',
		},
		description: {
			da: `Viser hvor mange af de kunder, der kommer i butikken, som køber noget.
			<br />Hvis I hæver kvaliteten eller butiksoplevelsen eller sænker prisen, vil flere kunder købe noget.`,
			kl: `Pisiniani pisiniarfimmut isertuni pisisut takutinneqarput.
			<br />Pitsaassuseq imaluunniit pisiniarfimmi misigisaq qaffatsikkussiuk imaluunniit aki apparlugu pisiniat amerlanerit pisiaqassapput.`
		}
	}
];

module.exports = {
	dictionaryData
}